import React from 'react'
import { Modal } from 'antd'

const RejectModal = ({open,closeHandler,value,setValue,onSubmit}) => {
  return (
    <Modal
        centered
        open={open}
        onCancel={(e) => closeHandler(!open)}
        width={500}
        title="Reason"
        zIndex={9999}
        footer={
        <div className="row">
            <div className="col-md-12">
            <button
                className={`btn ${
                value.trim() !== ""
                    ? "btn-primary"
                    : "btn-secondary"
                }`}
                disabled={value.trim() !== "" ? false : true}
                onClick={() => onSubmit()}
            >
                Submit
            </button>
            </div>
        </div>
        }
    >
        <div>
        <div className="form-group col-md-12 form-builder-element">
            <label htmlFor="">Type your reason</label>
            <textarea
            placeholder="Enter Your Reason"
            className="border form-control"
            onChange={(e) => setValue(e.target.value)}
            value={value}
            ></textarea>
        </div>
        </div>
    </Modal>
  )
}

export default RejectModal